import { CLICK_EVENT } from './constants';

export default class Filter {
    constructor({
        elm,
        filterDataAttr,
        dropdownDataAttr,
        displayDropdownCallback,
        displayMobileMenuCallback,
    }) {
        const dataAttribute = `[${filterDataAttr}]`;
        const mobileDataAttribute = `[${filterDataAttr}-mobile]`;
        this.mobileFilterBtn = elm?.querySelector(mobileDataAttribute);
        this.displayMobileMenu = displayMobileMenuCallback;
        this.filterBtn = elm?.querySelector(dataAttribute);
        this.dropdown = elm?.querySelector(`[${dropdownDataAttr}]`);
        this.checkboxInputs = this.dropdown
            ? Array.from(this.dropdown.querySelectorAll('input[type=checkbox]'))
            : this.dropdown;
        this.displayDropdown = displayDropdownCallback;

        this.mobileFilterBtn?.addEventListener(
            CLICK_EVENT,
            this.displayMobileDropDown.bind(this),
        );

        this.filterBtn?.addEventListener(
            CLICK_EVENT,
            this.displayFilterDropdown.bind(this),
        );
    }

    setCheckmarkInputsByName(listOfNames) {
        const dict = Object.assign(
            {},
            ...listOfNames.map((idStr) => ({ [idStr]: idStr })),
        );
        const foundInputNodes = [];
        this.checkboxInputs.forEach((checkmarkInput) => {
            if (checkmarkInput?.id in dict) {
                checkmarkInput.checked = true;
                foundInputNodes.push(checkmarkInput);
            }
        });
        return foundInputNodes;
    }

    displayFilterDropdown(e) {
        this.displayDropdown(
            e,
            this.filterBtn,
            this.dropdown,
            this.checkboxInputs,
        );
    }

    displayMobileDropDown(e) {
        this.displayMobileMenu(
            e,
            this.filterBtn,
            this.dropdown,
            this.checkboxInputs,
        );
    }
}
